import { render } from "./Form.vue?vue&type=template&id=47169f2f"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"

import "./Form.vue?vue&type=style&index=0&id=47169f2f&lang=css"
script.render = render

export default script